export default {
  FETCH_ALL: 'USER_GROUPS/FETCH_ALL',
  ADD_ALL: 'USER_GROUPS/ADD_ALL',
  FETCH_ALL_BADGES: 'USER_GROUP_BADGES/FETCH_ALL',
  SET_ALL_BADGES: 'USER_GROUP_BADGES/SET_ALL',
}
